/**
 * Utilitaires PURS du contrôle de purge unifié (`PurgeByDateControl`).
 *
 * Sémantique tranchée avec l'utilisateur : « purger JUSQU'À cette date » INCLUT le
 * jour choisi. Le backend supprime les entrées `ts < before` → pour couvrir toute
 * la journée locale sélectionnée, le client envoie `before` = début du jour
 * SUIVANT (minuit du lendemain, en ISO 8601). Le défaut = aujourd'hui ⇒ `before`
 * = demain minuit ⇒ purge TOUT le passé (rien dans le futur à conserver).
 *
 * Isolé et pur pour être testé sans DOM (calcul de date déterministe).
 */

/** Formate une `Date` locale en `YYYY-MM-DD` (valeur d'un `<input type="date">`). */
export function toDateInputValue(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Valeur par défaut du champ : la date du JOUR (locale). */
export function todayInputValue(now: Date = new Date()): string {
  return toDateInputValue(now);
}

/**
 * Convertit la date sélectionnée (`YYYY-MM-DD`, jour local) en borne `before` ISO
 * pour la purge : minuit du jour SUIVANT, en heure locale. Ainsi `ts < before`
 * inclut toute la journée choisie. Renvoie `null` si la chaîne est invalide.
 */
export function purgeBeforeIso(dateInput: string): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateInput);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  // Minuit LOCAL du lendemain : `Date(y, m-1, d+1)` normalise les débordements
  // de mois/année (ex. 31 déc. → 1er janv.). `toISOString()` sérialise en UTC.
  const next = new Date(year, month - 1, day + 1, 0, 0, 0, 0);
  if (Number.isNaN(next.getTime())) return null;
  return next.toISOString();
}
